var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9657 13.0829C23.697 8.02138 19.5078 4 14.3793 4C11.6458 4 9.09515 5.14966 7.28806 7.12893C6.99016 7.45522 7.01317 7.96123 7.33945 8.25913C7.66574 8.55704 8.17175 8.53403 8.46966 8.20774C9.9767 6.55712 12.1002 5.6 14.3793 5.6C18.5416 5.6 21.9614 8.7786 22.3438 12.8408L21.4122 12.0647L21.3241 12.0009C20.9902 11.7916 20.5447 11.856 20.2854 12.1672C20.0026 12.5066 20.0485 13.0111 20.3879 13.2939L23.3 15.7207L26.2122 13.2939L26.2909 13.2188C26.5569 12.9281 26.5739 12.4783 26.3146 12.1672L26.2395 12.0885C25.9488 11.8224 25.499 11.8055 25.1879 12.0647L23.9657 13.0829ZM2.68544 15.0328C2.42616 14.7217 2.44309 14.2719 2.70915 13.9812L2.78787 13.9061L5.70002 11.4793L8.61217 13.9061C8.95159 14.1889 8.99745 14.6934 8.7146 15.0328C8.45532 15.344 8.00983 15.4084 7.67594 15.1991L7.58787 15.1353L6.39753 14.1437C6.67703 18.3084 10.1438 21.6 14.3793 21.6C16.6583 21.6 18.7815 20.6431 20.2886 18.9928C20.5865 18.6665 21.0925 18.6435 21.4188 18.9415C21.745 19.2394 21.768 19.7454 21.4701 20.0717C19.663 22.0506 17.1126 23.2 14.3793 23.2C9.31559 23.2 5.16754 19.2794 4.80506 14.3082L3.81217 15.1353C3.50103 15.3945 3.05122 15.3776 2.76055 15.1115L2.68544 15.0328Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ac67e3ce.svg";
export { ForwardRef as ReactComponent };